import { css } from 'styled-components';
import { SessionInactiveModalProps } from './models';

export const SessionInactiveModal = css<SessionInactiveModalProps>(({ theme }) => {
  return css`
    background-color: white;
    border-radius: 16px;
    box-shadow: 0 8px 28px -6px ${theme.colors.lightGray};
    margin: auto;
    min-width: 320px;
    max-width: 525px;

    > .inactive-content-text {
      padding: 0;
      text-align: center;

      > .modal-text {
        @media only screen and ${theme.device.tablet} {
          padding: 0 37px;
        }

        > .broken-link-icon {
          width: 68px;
          margin-bottom: 10px;

          @media only screen and ${theme.device.tablet} {
            width: 100px;
          }
        }

        > .title {
          color: ${theme.colors.primaryDeepBlue};
          font-size: 18px;
          font-weight: 700;
          line-height: 21.8px;
          margin-bottom: 24px;
          white-space: break-spaces;

          @media only screen and ${theme.device.tablet} {
            font-weight: 600;
            font-size: 25px;
            line-height: 21.8px;
            white-space: normal;
          }
        }

        > .description {
          font-weight: 400;
          font-size: 14px;
          margin-bottom: 37px;

          @media only screen and ${theme.device.tablet} {
            font-weight: 400;
            font-size: 14px;
            line-height: 21px;
          }

          > .countdown {
            color: ${theme.colors.primaryBright};
          }
        }
      }

      .close-modal {
        min-width: 300px;

        .text {
          white-space: nowrap;
        }
      }
    }
  `;
});
